<template>
  <img :src="displaySrc" :alt="alt" :style="{ objectFit: fit }" @error="onImageError">
</template>

<script>
import axios from 'axios'
import store from '@/store'

const EMPTY_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='

export default {
  name: 'ProtectedCover',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    fit: { type: String, default: 'cover' }
  },
  data() { return { displaySrc: EMPTY_IMAGE, objectUrl: null, loadRevision: 0 } },
  watch: {
    src: { immediate: true, handler() { this.loadImage() } },
    '$store.state.token'() { if (this.src.indexOf('/api/covers/') === 0) this.loadImage() }
  },
  beforeDestroy() { this.releaseObjectUrl() },
  methods: {
    async loadImage() {
      const revision = ++this.loadRevision
      this.releaseObjectUrl()
      const source = this.src || ''
      if (!source) { this.displaySrc = EMPTY_IMAGE; return }
      if (/^data:/i.test(source) || !/^https?:|^\//i.test(source) || source.indexOf('/api/covers/') !== 0) {
        this.displaySrc = source
        return
      }
      try {
        const token = store.state.token
        const response = await axios.get(source, {
          responseType: 'blob',
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        })
        if (revision !== this.loadRevision) return
        this.objectUrl = URL.createObjectURL(response.data)
        this.displaySrc = this.objectUrl
      } catch (error) {
        if (revision !== this.loadRevision) return
        this.displaySrc = EMPTY_IMAGE
        this.$emit('error', error)
      }
    },
    releaseObjectUrl() {
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    },
    onImageError(error) {
      this.displaySrc = EMPTY_IMAGE
      this.$emit('error', error)
    }
  }
}
</script>

<style scoped>
img { position: absolute; inset: 0; display: block; width: 100%; height: 100%; }
</style>
